import React from "react";
import { Link } from "react-router-dom";
import { usePublicConfig } from "../lib/useConfig";

export const Footer = () => {
  const config = usePublicConfig();
  return (
    <footer className="relative bg-navy text-ivory grain overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="inline-block w-2.5 h-2.5 bg-gold rotate-45" />
              <span className="font-display font-bold text-lg">FundReady Lab</span>
            </div>
            <p className="text-ivory/70 text-sm leading-relaxed max-w-md">
              An honest look at what's working in your fundraising, what needs attention, and where you have the
              best shot at raising money — for nonprofits, community organizations, churches, and founders just
              getting started.
            </p>
          </div>
          <div>
            <h4 className="font-display font-semibold text-sm text-gold mb-4 uppercase tracking-wider">Product</h4>
            <ul className="space-y-2.5 text-sm text-ivory/70">
              <li><Link to="/how-it-works" className="hover:text-gold transition-colors">How It Works</Link></li>
              <li><Link to="/pricing" className="hover:text-gold transition-colors">Pricing</Link></li>
              <li><Link to="/faq" className="hover:text-gold transition-colors">FAQ</Link></li>
              <li><Link to="/assessment/new" className="hover:text-gold transition-colors">Check Your Funding Readiness</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-semibold text-sm text-gold mb-4 uppercase tracking-wider">Company</h4>
            <ul className="space-y-2.5 text-sm text-ivory/70">
              <li><Link to="/about" className="hover:text-gold transition-colors">About</Link></li>
              <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
              <li><Link to="/privacy" className="hover:text-gold transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-gold transition-colors">Terms of Use</Link></li>
              <li><Link to="/disclaimer" className="hover:text-gold transition-colors">Disclaimer</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-ivory/15">
          <p className="text-ivory/50 text-xs leading-relaxed max-w-3xl">
            {config?.disclaimer_short || "FundReady Lab provides strategic fundraising-readiness guidance. Results do not guarantee funding, grant awards, donations, sponsorships, or investment."}
          </p>
          <p className="text-ivory/40 text-xs mt-4">© {new Date().getFullYear()} FundReady Lab. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
